export const TEST_ID_HOTEL_RATING_CONTAINER = 'TEST_ID_HOTEL_RATING_CONTAINER';
